import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLinkedLogins } from 'api/account';
import APDropdown from 'components/Dropdown/APDropdown';
import DropdownButton from 'components/Button/DropdownButton/DropdownButton';
import { GET_LINKED_ACCOUNTS } from 'containers/App/constants';
import './style.scss';

const AccountSwitcher = () => {
  const dispatch = useDispatch();

  const [showModeSelect, setShowModeSelect] = useState(false);

  const updateLinkedAccounts = (payload) => {
    dispatch({
      type: GET_LINKED_ACCOUNTS,
      payload,
    });
  };

  const userInfo = useSelector((state) => state.global.userInfo);
  const _linkedAccounts = useSelector((state) => state.global.linkedAccounts);

  // Add username to the account if duplicate Org members/owner exist to differentiate accounts within the same org.
  const linkedAccounts = useMemo(() => {
    if (Array.isArray(_linkedAccounts)) {
      if (_linkedAccounts.length <= 1) return _linkedAccounts;
      // #TODO: linked accounts org name is the 'name' property. Should be renamed to 'orgName'.
      const orgs = _linkedAccounts.map(user => user.name);
      const orgNameCounts = orgs.reduce((orgCount, name) => {
        if (name in orgCount) {
          orgCount[name] += 1;
        } else {
          orgCount[name] = 1;
        }
        return orgCount;
      }, {});
      const hasDuplicateOrgs = Object.keys(orgNameCounts).some(orgName => orgNameCounts[orgName] > 1);

      if (!hasDuplicateOrgs) return _linkedAccounts;

      return _linkedAccounts.map(user => {
        if (user.name) {
          if (orgNameCounts[user.name] > 1) {
            return { ...user, name: `${user.name} (${user.username})` };
          }
        }
        return user;
      });
    }
    return [];
  }, [_linkedAccounts]);

  useEffect(() => {
    const getlinked =  async () => {
      return getLinkedLogins();
    };
    getlinked().then(response => {
      const { data } = response;
      updateLinkedAccounts(data);
    });
  }, []);

  const handleAccountClick = (account) => {
    window.location.href = `/account-switch?id=${account.id}`;
  };

  const dropdownTrigger = (
    <DropdownButton
      isOpen={showModeSelect}
      showIcon
      className="button--unstyled linked-accounts__trigger"
    >
      {userInfo?.organization?.name || 'Select company...'}
    </DropdownButton>
  );

  return (
    <div className="color-appbar-account-switcher">
      {linkedAccounts.length && !(linkedAccounts.length === 1 && linkedAccounts[0]?.current) ? (
        <li className="linked-accounts">
          <APDropdown
            isOpen={showModeSelect}
            show={() => setShowModeSelect(true)}
            dismiss={() => setShowModeSelect(false)}
            triggerButton={dropdownTrigger}
            scrollLockOnOpen={false}
            placement="bottom-start"
          >
            {linkedAccounts
              .filter(account => !account.current)
              .sort((a, b) => a.name.localeCompare(b.name))
              .map(account => {
                return (
                  // <a href={`/account-switch?id=${account.id}`}>{account.name ? account.name : account.email}</a>
                  <button
                    key={`account-${account.id}`}
                    className='action_buttons__button button--unstyled button--menu linked-accounts__menu-item'
                    onClick={() => handleAccountClick(account)}
                  >
                    {account.name ? account.name : account.email}
                  </button>
                );
            })}
          </APDropdown>
        </li>
      ) : null}
    </div>
  );
};

export default AccountSwitcher;
